module.exports = __webpack_public_path__ + "img/icon11.06e8ba2d.png";